module.exports = __webpack_public_path__ + "static/media/promo_pickup_banner.89bd579f.jpg";